import { Grid, makeStyles } from '@material-ui/core'
import IconAndText from 'components/common/IconAndText'
import React from 'react'

const useStyles = makeStyles(theme => ({
  countField: {
    padding: '0 8px',
    fontWeight: 600
  },
  text: {
    color: '#001335',
    fontSize: 13,
    fontWeight: 500
  }
}))

const SentimentWithCount = ({ containerClassName, scoreOption, onCategoryClicked, selected = false }) => {
  const classes = useStyles({ isTransparent: scoreOption.value === 0, selected })

  return (
    <Grid
      item
      className={containerClassName}
      style={{
        opacity: scoreOption.value === 0 ? 0.4 : 1,
        backgroundColor: selected ? '#7E8DF3' : scoreOption.value === 0 ? '#F6F6F6' : '#E7EAFF',
        color: selected ? '#FFFFFF' : '#001335',
        pointerEvents: scoreOption.value === 0 ? 'none' : 'auto',
        border: selected ? '2px solid #3C52EF' : 'none'
      }}
      onClick={() => onCategoryClicked(scoreOption.key)}
    >
      <IconAndText
        margin="10px"
        className={classes.text}
        text={scoreOption.label}
        icon={React.createElement(scoreOption.icon, {
          fillColor: scoreOption.fillColor,
          strokeColor: scoreOption.strokeColor,
          size: 'small'
        })}
      />
      <span className={classes.countField}>{scoreOption.value}</span>
    </Grid>
  )
}

export default SentimentWithCount
